module.exports = __webpack_public_path__ + "static/blueCar-b5d3e96a0a4baa4016ee3455f06df3c9.jpg";